import React from 'react';
import CustomModal from './CustomModal';

/**
 * Diálogo de confirmación — equivalente al `Club_Alert dialog` de Figma.
 *
 * Sustituye a los `window.confirm` repartidos por la app, que no dicen sobre qué
 * actúan ni qué se llevan por delante. Aquí el nombre va en el título y las
 * consecuencias en el cuerpo, con un aviso aparte cuando hace falta.
 *
 * @param {'danger'|'default'} tone  danger pinta el botón de confirmar en rojo.
 * @param {React.ReactNode} children  controles entre la descripción y el aviso
 *   (p. ej. cuántas unidades quitar). Opcional: sin él, el diálogo de siempre.
 */
export default function ConfirmDialog({
  active,
  title,
  description = null,
  note = null,
  confirmLabel = 'Aceptar',
  cancelLabel = 'Cancelar',
  tone = 'default',
  busy = false,
  onConfirm,
  onCancel,
  titleId = 'confirm-dialog-title',
  children = null,
}) {
  if (!active) return null;

  const footer = (
    <>
      <button type="button" className="wa-btn-secondary" onClick={onCancel} disabled={busy}>
        {cancelLabel}
      </button>
      <button
        type="button"
        className={tone === 'danger' ? 'wa-btn-danger' : 'wa-btn-primary'}
        onClick={onConfirm}
        disabled={busy}
      >
        {busy ? 'Un momento…' : confirmLabel}
      </button>
    </>
  );

  return (
    <CustomModal
      active={active}
      handleModal={busy ? () => {} : onCancel}
      title={title}
      size="sm"
      titleId={titleId}
      footer={footer}
    >
      <div className="space-y-3">
        {description && (
          <p className="text-sm text-[var(--wa-muted-foreground)]">{description}</p>
        )}
        {children}
        {note && (
          <p className="rounded-lg border border-[var(--destructive-border)] bg-[var(--destructive-bg)] px-3 py-2 text-xs leading-5 text-[var(--toast-error-text)]">
            {note}
          </p>
        )}
      </div>
    </CustomModal>
  );
}
